"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViralEnhancers = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const OrOptions_1 = require("../../inputs/OrOptions");
const SelectOption_1 = require("../../inputs/SelectOption");
const CardName_1 = require("../../CardName");
const ResourceType_1 = require("../../ResourceType");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
const CardRenderer_1 = require("../render/CardRenderer");
const Resources_1 = require("../../Resources");
class ViralEnhancers extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.VIRAL_ENHANCERS,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.MICROBE],
            cost: 9,
            metadata: {
                cardNumber: '074',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.plants(1).played.slash().microbes(1).played.slash().animals(1).played.br;
                    b.effect('When you play a Plant, Microbe, or an Animal tag, including this, gain 1 plant or add 1 resource to THAT CARD.', (eb) => {
                        eb.empty().startEffect;
                        eb.plants(1).slash().microbes(1).asterix().slash().animals(1).asterix();
                    });
                }),
            },
        });
    }
    onCardPlayed(player, card) {
        if (!player.cardIsInEffect(this.name))
            return;
        const resourceCount = card.tags.filter((tag) => tag === Tags_1.Tags.ANIMAL || tag === Tags_1.Tags.PLANT || tag === Tags_1.Tags.MICROBE).length;
        if (resourceCount === 0) {
            return undefined;
        }
        if (card.resourceType !== ResourceType_1.ResourceType.ANIMAL && card.resourceType !== ResourceType_1.ResourceType.MICROBE) {
            player.addResource(Resources_1.Resources.PLANTS, resourceCount, { log: true });
            return undefined;
        }
        for (let i = 0; i < resourceCount; i++) {
            player.game.defer(new DeferredAction_1.DeferredAction(player, () => new OrOptions_1.OrOptions(new SelectOption_1.SelectOption('Add resource to card ' + card.name, 'Add resource', () => {
                player.addResourceTo(card, { log: true });
                return undefined;
            }), new SelectOption_1.SelectOption('Gain plant', 'Save', () => {
                player.addResource(Resources_1.Resources.PLANTS, 1, { log: true });
                return undefined;
            }))));
        }
        return undefined;
    }
    play() {
        return undefined;
    }
}
exports.ViralEnhancers = ViralEnhancers;
//# sourceMappingURL=ViralEnhancers.js.map